import { Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { RightContainer } from "../../components/RightContainer";
import WhiteInosio from "../../icons/whiteinosio.svg"
import randomquotes from '../../random_quotes.json';
interface Props {}

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    borderRadius: "24px",
  },
  rightContainer: {
    background: "#053742",
    width: "59%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    height: "100%",
  },
  leftContainer: {
    borderRadius: "24px 0px 0px 24px",
    background: "#ffffff",
    width: "42%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  mainTitle: {
    fontFamily: "BMW Helvetica 75 !important",
    fontStyle: "normal",
    fontSize: "24px !important",
    lineHeight: "30px !important",
    color: "#14142B",
    margin: "0 16px !important",
  },
  PMBox: {
    width: "60% !important",
    margin: "10px 0 !important",
  },
  PMBoxIpad: { width: "58vw !important", margin: "10px 0 !important" },
  PMText: {
    fontSize: "18px !important",
    textAlign: "center",
  },
  buttonContainer: {
    width: "340px",
    display: "flex",
    flexDirection: "row",
    alignItems: "space-between",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  buttonContainerMobile: {
    width: "80vw",
    display: "flex",
    flexDirection: "column",
    marginTop: "300px",
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    width: "340px",
  },
  ResBtn: {
    border: "1px solid #39A2DB !important",
    width: "163px",
    height: "49px",
    borderRadius: "24px !important",
  },
  ResBtnMobile: {
    border: "1px solid #39A2DB !important",
    width: "80vw",
    height: "49px",
    borderRadius: "24px !important",
    marginBottom:"13px !important" 
  },
  SignUpBtn: {
    background: "#39A2DB !important",
    borderRadius: "24px !important",
    color: "#fff !important",
    width: "90px",
  },
  SignUpBtnMobile:{
    background: "#39A2DB !important",
    borderRadius: "24px !important",
    color: "#fff !important",
    width: "80vw",
  },
}));

export const PMPage = (props: Props) => {
  const matchesMobile = useMediaQuery("(max-width:600px)");
  const matchesIpad = useMediaQuery("(max-width:786px)");
  const matches900 = useMediaQuery("(max-width:900px)");
  const matches1200 = useMediaQuery("(max-width:1200px)");
  const randomQuoteIndex = Math.floor(Math.random() * randomquotes.length);  
  const loremIpsumPlaceholder: string = randomquotes[randomQuoteIndex].quote;

  const classes = useStyles();
  return (
    <div className={classes.rootContainer}>
      <Grid sx={{ flexDirection: "column" }} className={classes.leftContainer}>
        <Box pb={6} sx={{ display: "flex", alignItems: "center" }}>
          <img src={WhiteInosio} style={{ width: "150px", height: "150px" }} alt="logo" />
        </Box>
        <Box className={`${matchesIpad ? classes.PMBoxIpad : classes.PMBox}`}>
          {!matchesMobile ? (
            <Typography className={classes.PMText}>
              Sign Up to use Inosio at your Properties. If your company already
              uses Inosio, contact your administrator for an account
            </Typography>
          ) : (
            <Typography className={classes.PMText}>
              check your email or contact your property manager to sign up
            </Typography>
          )}
        </Box>

        <Box
          className={`${
            !matchesMobile
              ? classes.buttonContainer
              : classes.buttonContainerMobile
          }`}
        >

          <Button href="/residentpage" className={`${
            !matchesMobile
              ? classes.ResBtn
              : classes.ResBtnMobile
          }`}>
            I’m a Resident
          </Button>

          <Button className={`${
            !matchesMobile
              ? classes.SignUpBtn
              : classes.SignUpBtnMobile
          }`}>Sign Up</Button>
        </Box>
      </Grid>

      {!(matches900 && matches1200) ? (
        <Grid className={classes.rightContainer}>
          <RightContainer textPlaceholder={loremIpsumPlaceholder} />
        </Grid>
      ) : (
        <></>
      )}
    </div>
  );
};
